import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
 
const useUnitDetailsStyles = makeStyles<{}>()(theme => ({
  container: {
    background: theme.palette.system.white,
    border: `1px solid ${theme.palette.system.lightGrey}`,
    borderRadius: '4px',
    opacity: 1,
    position: 'relative',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '48px',
    background: theme.palette.system.white,
    opacity: 1,
    alignItems: 'center',
  },
  titleSubSection: {
    paddingLeft: '12px',
  },
 
  titleSubSectionIcon: {
    paddingRight: '14px',
  },
  titleStyles: {
    color: theme.palette.system.black,
    fontWeight: '500',
    fontSize: '16px !important',
  },
}));
 
const CardFormComponent = ({ icon, title, children , newIcon }: { icon?; title: string; children?, newIcon? }) => {
  const { classes } = useUnitDetailsStyles({});
 
  return (
    <Grid container item direction="column" className={classes.container} data-testId="order-details-card">
      <Grid container item className={classes.header}>
        <Grid item className={classes.titleSubSection}>
          <Typography className={classes.titleStyles}>{title}</Typography>
        </Grid>
        <Grid item className={classes.titleSubSectionIcon}>
          <Box component="span">{icon}</Box> <Box component="span">{newIcon}</Box>
        </Grid>
      </Grid>
 
      <Grid container item p={2}>
        {children}
      </Grid>
    </Grid>
  );
};
 
export default CardFormComponent;